import React from 'react';
import useDocumentTitle from './useDocumentTitle'
import NavbarEmpty from './emptyNavbar';
import DesignSidebar from './designSidebar';


export default function RotaryTool() {
  useDocumentTitle("Design Tool | FRC101 by the Spartabots")
  return (
    <div>
      <NavbarEmpty />
      <div class="flex max-w-[100rem] mx-auto my-5 bg-gradient-to-r from-frcyellow to-frcpurple rounded-[2rem] items-center">
        <p class="font-scoutcond font-black italic text-white opacity-30 text-[30rem] ml-10 leading-none">101</p>
        <h class="z-20 absolute font-scoutcond font-black italic text-frcblue text-[10rem] ml-40 leading-none">DESIGN TOOL</h>
        <p class="absolute ml-[9.4rem] mt-44 font-scoutcond font-black italic text-white text-[4rem] leading-none">RPM AND SPEED CALCULATOR</p>
      </div>
      <div class="flex flex-row max-w-[100rem] mx-auto mb-5" id="tool">
        <div class="hidden md:flex basis-80 bg-gray-300 rounded-l-[2rem]">
          <DesignSidebar />
        </div>
        <div class="basis-full bg-gray-50 rounded-r-[2rem]">
          <div class="mx-10 my-10">
            <h class="font-scoutcond font-black italic text-[5rem] leading-none">ROTARY MECHANISM CALCULATOR</h>
            <p class="font-productsans font-bold text-3xl text-gray-500 mb-5">For all kinds of rotary mechanisms</p>
            <Calculator />
          </div>
        </div>
      </div>
    </div>
  )
}

function round(num, places) {
  var multiplier = Math.pow(10, places);
  return Math.round(num * multiplier) / multiplier;
}

function outputValue(value) {
  const input = parseFloat(value);
  if (Number.isNaN(input) || input === 0) {
    return '';
  }
  return (value).toString();
}

const scaleNames = {
  rpm: "Free speed (RPM)",
  stall: "Stall torque (Nm)",
  freeAmps: "Free current (Amps)",
  stallAmps: "Stall current (Amps)",
  motorPer: "Motors per gearbox",
  weight: "Arm load (lbs)",
  armLength: "Arm length (in)",
  efficiency: "Gearbox efficiency",
  ratio1: "Gear ratio 1 driving",
  ratio2: "Gear ratio 2 driving",
  ratio3: "Gear ratio 3 driving",
  ratio4: "Gear ratio 4 driving"
}

class GenericInput extends React.Component {
  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(e) {
    this.props.onChange(e.target.value);
  }

  render() {
    const value = this.props.value;
    const scale = this.props.scale;
    return (
      <fieldset>
        <legend class="font-productsans font-bold">{scaleNames[scale]}:</legend>
        <input class="font-productsans font-bold bg-gray-500 text-white px-1 rounded-md" value={value}
          onChange={this.handleChange} />
      </fieldset>
    );
  }
}

class EmptyInput extends React.Component {
  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(e) {
    this.props.onChange(e.target.value);
  }

  render() {
    const value = this.props.value;
    return (
      <fieldset>
        <legend class="font-productsans font-bold mx-2">Driven:</legend>
        <input class="font-productsans mx-2 font-bold bg-gray-500 text-white px-1 rounded-md" value={value}
          onChange={this.handleChange} />
      </fieldset>
    );
  }
}

class Dropdown extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    this.props.onChange(e.target.value);
  }

  render() {
    return (
      <div class="mb-2">
        <p class="font-productsans font-bold text-xl">Motor Presets:</p>
        <select value={this.props.motor} onChange={this.handleChange} class="bg-gray-500 rounded-md font-productsans font-bold text-lg text-white p-1">
          <option name="cim">CIM</option>
          <option name="minicim">Mini CIM</option>
          <option name="bag">BAG Motor</option>
          <option name="775pro">775 Pro</option>
          <option name="am775">AM 775</option>
          <option name="bb550">Banebots 550</option>
          <option name="bbrs775">Banebots RS775</option>
          <option name="neo">NEO Brushless</option>
          <option name="falcon">Falcon 500</option>
          <option name="neo550">NEO 550</option>
        </select>
      </div>
    );
  }
}

class Calculator extends React.Component {
  constructor(props) {
    super(props);
    this.handleMotorChange = this.handleMotorChange.bind(this);
    this.handleGearboxChange = this.handleGearboxChange.bind(this);

    this.handleRPMChange = this.handleRPMChange.bind(this);
    this.handleFreeCurrentChange = this.handleFreeCurrentChange.bind(this);
    this.handleStallChange = this.handleStallChange.bind(this);
    this.handleStallCurrentChange = this.handleStallCurrentChange.bind(this);
    this.handleMotorPerChange = this.handleMotorPerChange.bind(this);
    this.handleWeightChange = this.handleWeightChange.bind(this);
    this.handleLengthChange = this.handleLengthChange.bind(this)

    this.handleratio1DrivingChange = this.handleratio1DrivingChange.bind(this);
    this.handleratio2DrivingChange = this.handleratio2DrivingChange.bind(this);
    this.handleratio3DrivingChange = this.handleratio3DrivingChange.bind(this);
    this.handleratio4DrivingChange = this.handleratio4DrivingChange.bind(this);

    this.handleratio1DrivenChange = this.handleratio1DrivenChange.bind(this);
    this.handleratio2DrivenChange = this.handleratio2DrivenChange.bind(this);
    this.handleratio3DrivenChange = this.handleratio3DrivenChange.bind(this);
    this.handleratio4DrivenChange = this.handleratio4DrivenChange.bind(this);

    this.motor = "Falcon 500"
    this.gearbox = "SDS Mk4 L1"
    this.state = {
      rpm: '6380', stall: '4.69', freeAmps: '1.5', stallCurrent: '257', motor: 'Falcon 500',
      motorPer: '1', weight: '0', armLength: '1',
      ratio1Driving: '1', ratio1Driven: '1', ratio2Driving: '1', ratio2Driven: '1', ratio3Driving: '1', ratio3Driven: '1', ratio4Driving: '1', ratio4Driven: '1'
    };

  }

  handleMotorChange(motor) {
    this.setState({ motor }, () => this.runMotorCheck())
  }
  handleGearboxChange(gearbox) {
    this.setState({ gearbox }, () => this.runGearboxCheck())
  }

  handleRPMChange(rpm) {
    this.setState({ rpm })
  }
  handleFreeCurrentChange(freeAmps) {
    this.setState({ freeAmps })
  }
  handleStallChange(stall) {
    this.setState({ stall })
  }
  handleStallCurrentChange(stallCurrent) {
    this.setState({ stallCurrent })
  }
  handleMotorPerChange(motorPer) {
    this.setState({ motorPer })
  }
  handleWeightChange(weight) {
    this.setState({ weight })
  }
  handleLengthChange(armLength) {
    this.setState({ armLength })
  }

  handleratio1DrivingChange(ratio1Driving) {
    this.setState({ ratio1Driving })
  }
  handleratio2DrivingChange(ratio2Driving) {
    this.setState({ ratio2Driving })
  }
  handleratio3DrivingChange(ratio3Driving) {
    this.setState({ ratio3Driving })
  }
  handleratio4DrivingChange(ratio4Driving) {
    this.setState({ ratio4Driving })
  }

  handleratio1DrivenChange(ratio1Driven) {
    this.setState({ ratio1Driven })
  }
  handleratio2DrivenChange(ratio2Driven) {
    this.setState({ ratio2Driven })
  }
  handleratio3DrivenChange(ratio3Driven) {
    this.setState({ ratio3Driven })
  }
  handleratio4DrivenChange(ratio4Driven) {
    this.setState({ ratio4Driven })
  }

  runMotorCheck() {
    if (this.motor === "CIM") {
      this.handleRPMChange(5330)
      this.handleStallChange(2.41)
      this.handleFreeCurrentChange(2.7)
      this.handleStallCurrentChange(131)
    }
    if (this.motor === "Mini CIM") {
      this.handleRPMChange(5840)
      this.handleStallChange(1.41)
      this.handleFreeCurrentChange(3)
      this.handleStallCurrentChange(89)
    }
    if (this.motor === "BAG Motor") {
      this.handleRPMChange(13180)
      this.handleStallChange(0.43)
      this.handleFreeCurrentChange(1.8)
      this.handleStallCurrentChange(53)
    }
    if (this.motor === "775 Pro") {
      this.handleRPMChange(18730)
      this.handleStallChange(0.71)
      this.handleFreeCurrentChange(0.7)
      this.handleStallCurrentChange(134)
    }
    if (this.motor === "AM 775") {
      this.handleRPMChange(5800)
      this.handleStallChange(0.28)
      this.handleFreeCurrentChange(1.6)
      this.handleStallCurrentChange(18)
    }
    if (this.motor === "Banebots 550") {
      this.handleRPMChange(19000)
      this.handleStallChange(0.38)
      this.handleFreeCurrentChange(0.4)
      this.handleStallCurrentChange(84)
    }
    if (this.motor === "Banebots RS775") {
      this.handleRPMChange(13050)
      this.handleStallChange(0.72)
      this.handleFreeCurrentChange(2.7)
      this.handleStallCurrentChange(97)
    }
    if (this.motor === "NEO Brushless") {
      this.handleRPMChange(5760)
      this.handleStallChange(2.2)
      this.handleFreeCurrentChange(2)
      this.handleStallCurrentChange(80)
    }
    if (this.motor === "Falcon 500") {
      this.handleRPMChange(6380)
      this.handleStallChange(4.69)
      this.handleFreeCurrentChange(1.5)
      this.handleStallCurrentChange(257)
    }
    if (this.motor === "NEO 550") {
      this.handleRPMChange(11000)
      this.handleStallChange(0.97)
      this.handleFreeCurrentChange(1.4)
      this.handleStallCurrentChange(100)
    }
  }

  render() {
    const motorSelector = <Dropdown
      motor={this.state.motor}
      onChange={this.handleMotorChange} />
    this.motor = motorSelector.props.motor
    const ratio = this.state.ratio1Driving / this.state.ratio1Driven * this.state.ratio2Driving / this.state.ratio2Driven * this.state.ratio3Driving / this.state.ratio3Driven * this.state.ratio4Driving / this.state.ratio4Driven
    const overallRatio = round(this.state.ratio1Driven * this.state.ratio2Driven * this.state.ratio3Driven * this.state.ratio4Driven / this.state.ratio1Driving / this.state.ratio2Driving / this.state.ratio3Driving / this.state.ratio4Driving, 2)

    const currentDraw = round(((((this.state.stallCurrent*this.state.motorPer)-(this.state.freeAmps*this.state.motorPer))/(this.state.stall*this.state.motorPer))*(this.state.weight*this.state.armLength*ratio/(0.2248*39.37))+(this.state.freeAmps*this.state.motorPer))/this.state.motorPer, 2)
    const stallLoad = round(this.state.stall*this.state.motorPer*(1/ratio)*39.37*0.2248*0.9/this.state.armLength, 2)

    const freeSpeed = round(this.state.rpm * ratio * (360/60), 2)
    const loadedSpeed = round(((-1)*(freeSpeed/stallLoad)*(this.state.weight)+freeSpeed), 2)

    var loadedSpeedDisplay = outputValue(loadedSpeed) + " deg/sec"
    var loadedTimeDisplay = round(90/loadedSpeed, 3) + " sec"

    if (loadedSpeed < 0) {
      loadedSpeedDisplay = "Stalled"
      loadedTimeDisplay = "Stalled"
    }

    return (
      <div>
        <div class="flex">
          {motorSelector}
        </div>
        <div class="flex">
          <div>
            <GenericInput
              value={this.state.rpm}
              scale="rpm"
              onChange={this.handleRPMChange} />
            <GenericInput
              value={this.state.stall}
              scale="stall"
              onChange={this.handleStallChange} />
            <GenericInput
              value={this.state.freeAmps}
              scale="freeAmps"
              onChange={this.handleFreeCurrentChange} />
            <GenericInput
              value={this.state.stallCurrent}
              scale="stallAmps"
              onChange={this.handleStallCurrentChange} />
          </div>
          <div class="ml-20">
            <GenericInput
              value={this.state.motorPer}
              scale="motorPer"
              onChange={this.handleMotorPerChange} />
            <GenericInput
              value={this.state.weight}
              scale="weight"
              onChange={this.handleWeightChange} />
            <GenericInput
              value={this.state.armLength}
              scale="armLength"
              onChange={this.handleLengthChange} />
          </div>
          <div class="ml-20">
            <div class="flex">
              <GenericInput
                value={this.state.ratio1Driving}
                scale="ratio1"
                onChange={this.handleratio1DrivingChange} />
              <EmptyInput
                value={this.state.ratio1Driven}
                scale="ratio1Driven"
                onChange={this.handleratio1DrivenChange} />
            </div>
            <div class="flex">
              <GenericInput
                value={this.state.ratio2Driving}
                scale="ratio2"
                onChange={this.handleratio2DrivingChange} />
              <EmptyInput
                value={this.state.ratio2Driven}
                scale="ratio2Driven"
                onChange={this.handleratio2DrivenChange} />
            </div>
            <div class="flex">
              <GenericInput
                value={this.state.ratio3Driving}
                scale="ratio3"
                onChange={this.handleratio3DrivingChange} />
              <EmptyInput
                value={this.state.ratio3Driven}
                scale="ratio3Driven"
                onChange={this.handleratio3DrivenChange} />
            </div>
            <div class="flex">
              <GenericInput
                value={this.state.ratio4Driving}
                scale="ratio4"
                onChange={this.handleratio4DrivingChange} />
              <EmptyInput
                value={this.state.ratio4Driven}
                scale="ratio4Driven"
                onChange={this.handleratio4DrivenChange} />
            </div>
          </div>
        </div>
        <div class="flex w-full mt-10">
          <div>
            <div class="font-productsans font-bold text-xl flex w-[24rem] px-2 py-2 mt-2 bg-gradient-to-r from-frcyellow to-frcpurple rounded-[0.5rem] justify-between"><p>Free Speed:</p><p class="text-white">{outputValue(freeSpeed)} deg/sec</p></div>
            <div class="font-productsans font-bold text-xl flex w-[24rem] px-2 py-2 mt-3 bg-gradient-to-r from-frcyellow to-frcpurple rounded-[0.5rem] justify-between"><p>Loaded Speed:</p><p class="text-white">{loadedSpeedDisplay}</p></div>
          </div>
          <div class="mx-5">
            <div class="font-productsans font-bold text-xl flex w-[24rem] px-2 py-2 mt-2 bg-gradient-to-r from-frcyellow to-frcpurple rounded-[0.5rem] justify-between"><p>Time to move 90°:</p><p class="text-white">{round(90/freeSpeed, 3)} sec</p></div>
            <div class="font-productsans font-bold text-xl flex w-[24rem] px-2 py-2 mt-3 bg-gradient-to-r from-frcyellow to-frcpurple rounded-[0.5rem] justify-between"><p>Time to move 90°:</p><p class="text-white">{loadedTimeDisplay}</p></div>
          </div>
          <div>
            <div class="font-productsans font-bold text-xl flex w-[24rem] px-2 py-2 mt-2 bg-gradient-to-r from-frcyellow to-frcpurple rounded-[0.5rem] justify-between"><p>Stall Load:</p><p class="text-white">{outputValue(stallLoad)} lbs</p></div>
            <div class="font-productsans font-bold text-xl w-[24rem] px-2 py-2 mt-3 bg-gradient-to-r from-frcyellow to-frcpurple rounded-[0.5rem]">
              <div class="flex justify-between"><p>Loaded Current Draw:</p><p class="text-white">{ currentDraw } amps</p></div>
              <p class="font-productsans font-normal text-base">Per {this.state.motor}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}